import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import { connect } from 'react-redux';
import Message from './message';
import ChatArea from './chat_area';
import SettingsArea from './settings/settings_area';

import { setChatStatus } from 'actions';
import { submitMessage } from 'actions/live_weather_center';

import { viewChat,
		 deleteMessage,
		 setStatus,
		 clearMessages,
		 updateScreenName,
		 updateUserScreenName,
		 updateAvatars,
		 updateAvatar,
		 updateUserAvatar,
		 updateLWCFeed
} from 'actions';
import { sockets } from 'utils';
import { viewSettings } from 'actions';

class Chat extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this)
    this.updateHeight = this.updateHeight.bind(this)
    this.handleEnableChat = this.handleEnableChat.bind(this)
    this.handleDisableChat = this.handleDisableChat.bind(this)
    this.handleClearMessages = this.handleClearMessages.bind(this)
    this.handleScreenName = this.handleScreenName.bind(this);
    this.handleAvatar = this.handleAvatar.bind(this);
    this.handleSend = this.handleSend.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.socket = null
  }

  handleClick(event) {
  	if (this.props.liveWeatherCenter.viewSettings) {
  		this.props.dispatch(viewChat())
  	}
  	else {
  		this.props.dispatch(viewSettings())
  	}
  }
  updateHeight() {
  	var panel = $(ReactDom.findDOMNode(this.refs.panel));
    var height = $(window).height() - panel.offset().top - 3;
		panel.height(height);
  }
  componentDidMount() {
  	$(window).resize(this.udpateHeight);
   	this.updateHeight();
  }

  componentWillMount() {
    this.socket = sockets();

		// Request avatars
		this.socket.emit('get-avatars');
		this.socket.emit('chat-history-request');
		this.socket.emit('chat-state');

		// Load in avatars
		this.socket.on('avatars-received', (avatars, response) => {
			this.props.dispatch(updateAvatars({avatars}));
		});

		// Listen for chat-state update
		this.socket.on('chat-state', (data) => {
			const { enabled } = data;

			if (typeof enabled !== 'undefined') {
				this.props.dispatch(setChatStatus({enabled}));
			}
		});

		// Load chat history
		this.socket.on('chat-history-received', (messages, response) => {
			messages.map(m => this.props.dispatch(submitMessage(JSON.parse(m))));
		});

		// Listen to the `all` channel for globally broadcasted events.
		this.socket.watch('all', data => {
			let { event, avatars, id, screen_name, avatar, message, messages, enabled, feed_url } = data;

			switch(event) {
				case 'chat-username-updated':
					this.props.dispatch(updateScreenName({id, screen_name}));
	        if(this.props.user._id == id) {
				 		this.props.dispatch(updateUserScreenName({screen_name}));
				  }
					break;
				case 'chat-avatar-updated':
					if(this.props.user._id == id) {
	          this.props.dispatch(updateUserAvatar({avatar}));
	        }
					this.props.dispatch(updateAvatar({avatar, id}));
					break;
				case 'chat-new-message-received':
					this.props.dispatch(submitMessage(message));
					break;
				case 'chat-message-deleted':
					this.props.dispatch(deleteMessage(message));
					break;
				case 'chat-cleared':
					this.props.dispatch(clearMessages());
					break;
				case 'chat-state':
					if (typeof enabled !== 'undefined') {
            this.props.dispatch(setChatStatus({enabled}));
          }
					break;
				case 'chat-feed-updated':
					if (typeof feed_url !== 'undefined') {
						this.props.dispatch(updateLWCFeed(feed_url));
					}
				default:
					break;
			}
		});

		// Authenticated Administration channel
    this.socket.watch('live-weather-center', data => {
      // let {  } = data;

      // switch(event) {
			//
			// }
    });
  }

  handleEnableChat() {
		this.socket.emit('chat-state', {
			enabled: true
		})
	}

  handleDisableChat() {
  	this.socket.emit('chat-state', {
			enabled: false
		})
  }

  handleClearMessages() {
  	this.socket.emit('chat-clear-messages');
  }

  handleScreenName(screen_name) {
  	this.socket.emit('chat-update-username', {screen_name});
  }

  handleAvatar(avatar) {
  	this.socket.emit('chat-update-avatar', {avatar});
  }

  handleSend(message) {
    this.socket.emit('chat-new-msg', message);
  }

  handleDelete(message) {
    this.socket.emit('chat-message-delete', message);
  }

	handleFeedChange(url) {
		this.socket.emit('chat-feed-update', url);
	}

  render() {

    return (
  		<section
  			ref='panel'
  			className="panel"
  			id="chat-settings-wrapper">
  			<div className="chat-status-bar">
	  			<div
	  				className="glyphicon glyphicon-cog settings-button"
	  				onClick={this.handleClick}>
  				</div>
  			</div>

  			{(()=>{
  				if(!this.props.liveWeatherCenter.viewSettings && this.props.connection.user.screen_name && this.props.connection.user.avatar)
  					return (<ChatArea
                  onSend={this.handleSend}
                  onDelete={this.handleDelete}
				  				className="chat-area"
				  				socket={this.socket} />)
					else
						return (
							<SettingsArea
			  				socket={this.socket}
			  				onEnable={this.handleEnableChat}
			  				onDisable={this.handleDisableChat}
			  				onClear={this.handleClearMessages}
			  				onScreenNameChange={this.handleScreenName}
								onFeedChange={this.handleFeedChange}
			  				onAvatarChange={this.handleAvatar}/>
		  			)
  			})()}
  		</section>
    );
  }
}

function mapStateToProps({connection, liveWeatherCenter}) {
	return {
		connection,
		user: connection.user,
		liveWeatherCenter
	}
}

export default connect(mapStateToProps)(Chat)



// WEBPACK FOOTER //
// ./src/browser/components/live_weather_center/chat/main.js